import { mapState } from 'vuex'
import CodeListsService from '@/services/code-list'

export default {
  computed: {
    ...mapState({
      items (state) {
        return state.codeList.cache[this.key]
      },
    }),
    iValue () {
      return parseInt(this.$attrs.value)
    },
  },
  mounted () {
    if (this.items == null) {
      this.fetchData()
    }
  },
  methods: {
    fetchData () {
      const cs = new CodeListsService(this.key)
      cs.getForSelect().then((response) => {
        this.$store.commit('codeList/updateCache', { key: this.key, value: response.data.data })
      })
    },
    getValueTitle (id) {
      const iid = parseInt(id)
      for (const item of this.items) {
        if (iid === item.value) {
          return item.text
        }
      }
      return null
    },
  },
}
